export const user_routes = [
	{
        path: '/:lang([a-z]{2})',
        name: 'lang',
        // component: () => import('@/App.vue'),
        // props: { data: { page: "Default", data: {} } },
        // meta: { requireAuth: true },
        children: [
			{
				path: '',
				name: 'index',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Home" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'about',
				name: 'about',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/About" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'contacts',
				name: 'contacts',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Contacts" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'services',
				name: 'services',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Services" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'portfolio',
				name: 'portfolio',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Services" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			// {
			// 	path: '/shoping-cart',
			// 	name: 'shopingcart',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/ShopingCart" } },
			// 	// props: { data: { page: "Home", data: {uid: 1} } },
			// 	meta: { requireAuth: false },
			// 	// children: []
			// },
			// {
			// 	path: 'products_by_name/:search_text',
			// 	name: 'products_by_name',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Products" } },
			// 	meta: { requireAuth: false },
			// },
			{
                path: 'products/:category_id/:page/:perpage/:year_min/:year_max/:quarters/:price_min/:price_max/:sortfield/:sortorder/:filters/:search_text',
                name: 'products_by_page',
                component: () => import('@/layouts/Main'),
                props: { data: { page: "pages/Products" } },
                // meta: { requireAuth: true },
            },
			{
				path: 'products/:category_id',
				name: 'products_by_category',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Products" } },
				meta: { requireAuth: false },
			},
			{
				path: 'products',
				name: 'products',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Products" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'product/:id',
				name: 'product_info',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/ProductDetail" } },
				meta: { requireAuth: false },
			},
			// {
			// 	path: '/content',
			// 	name: 'contents',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Contents" } },
			// 	// props: { data: { page: "Home", data: {uid: 1} } },
			// 	meta: { requireAuth: false },
			// 	// children: []
			// },
			// {
			// 	path: '/:cat',
			// 	name: 'contents',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Contents" } },
			// 	meta: { requireAuth: false }
			// },
			// {
			// 	path: '/:cat/:id',
			// 	name: 'content',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/ContentDetail" } },
			// 	meta: { requireAuth: false },
			// },
		],
	},
	{
		path: '/notfound',
		name: 'notfound',
		component: () => import('@/layouts/404'),
		props: { data: { page: "pages/NotFound" } },
	},
	{
		path: '/:lang([a-z]{2})/:catchAll(.*)',
		// path: '/:catchAll(.*)',
		name: '404error',
		// redirect: 'notfound',
		// component: () => import('@/layouts/404'),
		// // props: { data: { page: "pages/NotFound" } },
		component: () => import('@/layouts/404'),
		props: { data: { page: "pages/NotFound" } },
		// beforeEnter (to, from, next) {
		// 	to.params.test = 'test'
		// 	next(to.params)
		// }
	},
];
